module.exports = __webpack_public_path__ + "static/media/family_illustration.df7b90f8.png";